import { Guid } from "@/Common/Models/Guid";
import { IPatient } from "@/Common/Models/Patient/IPatient";
import { Person } from "@/Common/Models/Person/Person";

class InternalPatientResponse implements IPatient {
    public ContactId: Guid;
    public ContactFacetId: Guid;
    public FirstName: string;
    public LastName: string;
    public PreferredName: string;
    public DateOfBirth: Date;
    public NAM: string;

    public get PatientId(): string {
        return this.ContactFacetId;
    }

    public isInternal(): boolean {
        return true;
    }

    public static fromResponse(item: Partial<InternalPatientResponse>): InternalPatientResponse {
        if (!item)
            return null;

        return (Object as any).assign(new InternalPatientResponse(), item);
    }

    public static fromPerson(item: Person): InternalPatientResponse {
        if (!item)
            return null;

        let model = new InternalPatientResponse();
        model.ContactId = item.ContactId;
        model.ContactFacetId = item.ContactFacetId;
        model.FirstName = item.FirstName;
        model.LastName = item.LastName;
        model.PreferredName = item.PreferredName;
        model.DateOfBirth = item.DateOfBirth;
        model.NAM = item.NAM;
        return model;
    }

    public static toPerson(item: InternalPatientResponse): Person {
        if (!item)
            return null;

        let model = new Person({
            ContactFacetId: item.ContactFacetId,
            ContactId: item.ContactId,
            FirstName: item.FirstName,
            LastName: item.LastName,
            PreferredName: item.PreferredName,
            DateOfBirth: item.DateOfBirth,
            NAM: item.NAM
        });
        return model;
    }
}

export { InternalPatientResponse };
